import { render, staticRenderFns } from "./PlanejamentoContratoFormRodape.vue?vue&type=template&id=1454405f"
import script from "./PlanejamentoContratoFormRodape.vue?vue&type=script&lang=js"
export * from "./PlanejamentoContratoFormRodape.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoContratoFormRodape.vue?vue&type=style&index=0&id=1454405f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports